import { Params } from './types';

const baseURL = 'https://dev-poscrm.mmms.ca/';

export function getURL(params: Params) {
  const url = new URL('EmailAcquisition', baseURL);

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.set(key, value);
  });

  return url;
}
